import type { ChargeSheetItemSection } from '~/types'

const isManualDiscountSource = (name?: string) =>
  typeof name === 'string' && name.trim().toLowerCase() === 'manual'

export const findHasManualDiscount = (
  chargeSheetItems: ChargeSheetItemSection[],
) =>
  chargeSheetItems
    .map((item) => item.groupedItems)
    .flat()
    .some((groupedItem) => {
      const items =
        Array.isArray(groupedItem.items) && groupedItem.items.length > 0
          ? groupedItem.items
          : [groupedItem]
      return items.some((item) =>
        isManualDiscountSource(item?.discountSource?.name),
      )
    })
